import axios from "axios";
const Service = axios.create({
  timeout: 30000, // 请求超时时间
  baseURL: "https://api.play.cn",
  method: "get",
  headers: {
    "Content-Type": "application/json;charset=UTF-8"
  }
});
const TVBaseURL = "https://open.play.cn";
/* eslint-disable @typescript-eslint/camelcase */
// 内容详情查询
export function getContentDetails(contentId) {
  return Service({
    url: `/api/v3/contents/${contentId}`,
    method: "GET",
    headers: {
      vc: "50000",
      channel_code: "20000044"
    }
  });
}

// 获取移动端版本号信息
export function getVersion() {
  return Service({
    url: "/api/v03/versions/info",
    headers: {
      channel_code: "00000000"
    }
  });
}
// 获取TV端版本号信息
// https://open.play.cn/api/v2/tv/cloud/hall/check_version.json?client_channel=70000001
export function getTVVersion() {
  return Service({
    baseURL: TVBaseURL,
    url: "/api/v2/tv/cloud/hall/check_version.json",
    params: {
      client_channel: 70000001,
      version: 1
    }
  });
}
